/**
 * What each browser says when a lazy chunk can no longer be loaded - in practice because a deploy
 * replaced the build this page was loaded from, so its `chunk-*.js` names no longer exist on the
 * server. See docs/web-releases.md.
 */
const CHUNK_LOAD_MESSAGES = [
  // Chromium
  'Failed to fetch dynamically imported module',
  // Firefox
  'error loading dynamically imported module',
  // Safari
  'Importing a module script failed',
  // Chromium, when the server answers the missing chunk with the SPA's index.html
  'is not a valid JavaScript MIME type',
]

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : ''
  return CHUNK_LOAD_MESSAGES.some((fragment) => message.includes(fragment))
}
